/**
 * @file 列表页-筛选区
 * @author alfielv
 */
import React, { useRef } from 'react';
import FilterDropdown from './Dropdown';
import FilterSearch from './Search';
import useOriginReference from '../../../hooks/useOriginReference';
export default (function (props) {
  var title = props.title,
      name = props.name,
      type = props.type,
      defaultValue = props.defaultValue,
      value = props.value,
      config = props.config,
      nameConfig = props.nameConfig,
      onFilterDataUpdate = props.onFilterDataUpdate,
      autoComplete = props.autoComplete,
      selectOnly = props.selectOnly,
      rules = props.rules,
      searchFunction = props.searchFunction,
      customComponent = props.component,
      clearKeys = props.clearKeys,
      clearable = props.clearable,
      defaultContent = props.defaultContent; // 存储传入的自定义组件，避免外部引起的反复重渲染

  var customComponentRef = useRef(customComponent); // 存储rules原始reference

  var rulesOriginRef = useOriginReference(rules); // 存储config原始reference

  var configOriginRef = useOriginReference(config); // 存储value原始reference

  var valueOriginRef = useOriginReference(value); // 存储clearKeys原始reference

  var clearKeysOriginRef = useOriginReference(clearKeys); // 存储nameConfig原始reference

  var nameConfigOriginRef = useOriginReference(nameConfig);

  if (type === 'search') {
    return /*#__PURE__*/React.createElement(FilterSearch, {
      title: title,
      name: name,
      defaultValue: defaultValue,
      value: valueOriginRef,
      config: configOriginRef,
      nameConfig: nameConfigOriginRef,
      autoComplete: autoComplete,
      selectOnly: selectOnly,
      rules: rulesOriginRef,
      clearable: clearable,
      searchFunction: searchFunction,
      onFilterDataUpdate: onFilterDataUpdate
    });
  }

  return /*#__PURE__*/React.createElement(FilterDropdown, {
    title: title,
    name: name,
    value: valueOriginRef,
    type: type,
    config: configOriginRef,
    nameConfig: nameConfigOriginRef,
    customComponentRef: customComponentRef,
    clearKeys: clearKeysOriginRef,
    clearable: clearable,
    onFilterDataUpdate: onFilterDataUpdate,
    defaultContent: defaultContent
  });
});